/* Aba Financeiro, em duas telas diferentes.

   Admin: o caixa do escritório. Todos os captadores, quanto cada um tem a
   receber, a chave PIX e a lista de parcelas para dar baixa.

   Captador: a pergunta dele é outra, "quanto eu já ganhei e quanto ainda vou
   receber". Não é a tela do admin com coluna escondida, é outra tela. Sem
   botão de dar baixa, porque quem paga é o escritório. O isolamento de
   verdade continua no Postgres: aqui é só o desenho certo para cada um. */

import { $, $$, esc, dataBR, toast, copiarTexto } from "../util.js";
import { S } from "../estado.js";
import { resumoComissoes, listaComissoes, marcarPaga,
         ETAPAS_COMISSAO, dinheiro } from "../api/comissoes.js";
import { rankingCaptadores } from "../api/captadores.js";
import { listarConvites, criarConvite } from "../api/convites.js";
import { abrirPix } from "./pix.js";

const NOME_ETAPA = Object.fromEntries(ETAPAS_COMISSAO.map(e => [e.id, e.nome]));
let soPendentes = true;

export async function renderFinanceiro(){
  const alvo = $("#vFinanceiro");
  alvo.innerHTML = `<p class="hint" style="padding:20px">Carregando...</p>`;

  /* O ranking não pode derrubar a tela. Se a migração 005 ainda não rodou,
     a função não existe no banco, e o resto do Financeiro tem que aparecer
     do mesmo jeito. */
  const pRanking = rankingCaptadores().catch(e => { console.warn("ranking:", e); return null; });

  try {
    if (S.souAdmin) await telaAdmin(alvo, pRanking);
    else            await telaCaptador(alvo, pRanking);
  } catch (e){
    alvo.innerHTML = `<div class="panel"><div class="empty">
      <h3>Não deu para carregar</h3>
      <p>${esc(e.message || e)}</p></div></div>`;
  }
}

/* ---------------------------------------------------------------- admin */

async function telaAdmin(alvo, pRanking){
  const [resumo, lista, ranking, convites] = await Promise.all([
    resumoComissoes(),
    listaComissoes(),
    pRanking,
    listarConvites().catch(e => { console.warn("convites:", e); return null; })
  ]);

  /* Quem nunca teve comissão não precisa aparecer na lista. */
  const linhas = resumo.filter(r => Number(r.total_geral) > 0 || r.captador_id === S.perfil?.id);

  const totalPendente = linhas.reduce((s, r) => s + Number(r.total_pendente), 0);
  const totalPago     = linhas.reduce((s, r) => s + Number(r.total_pago), 0);
  const visiveis      = soPendentes ? lista.filter(c => !c.pago) : lista;

  alvo.innerHTML = `
    <div class="fin-topo">
      <div class="fin-caixa">
        <span>A pagar</span>
        <b>${dinheiro(totalPendente)}</b>
      </div>
      <div class="fin-caixa">
        <span>Já pago</span>
        <b class="pago">${dinheiro(totalPago)}</b>
      </div>
    </div>

    ${linhas.length ? `<div class="panel" style="margin-bottom:14px">
      <div class="tbl-scroll"><table>
        <thead><tr>
          <th>Captador</th><th>Chave PIX</th>
          <th style="width:92px">A pagar</th><th style="width:92px">Pago</th>
        </tr></thead>
        <tbody>${linhas.map(r => `<tr>
          <td style="font-weight:600">${esc(r.captador || "sem nome")}</td>
          <td>${r.pix
            ? `<span class="pix-chave">${esc(r.pix)}</span>`
            : `<span style="color:var(--exig);font-size:12px">sem chave cadastrada</span>`}</td>
          <td class="mono" style="font-size:12.5px">${dinheiro(r.total_pendente)}</td>
          <td class="mono" style="font-size:12.5px;color:var(--muted)">${dinheiro(r.total_pago)}</td>
        </tr>`).join("")}</tbody>
      </table></div>
    </div>` : ""}

    <div class="fin-filtro">
      <button class="chipbtn" id="finPend" aria-pressed="${soPendentes}">Só o que falta pagar</button>
      <span class="hint">${visiveis.length} parcela${visiveis.length === 1 ? "" : "s"}</span>
    </div>

    ${visiveis.length ? `<div class="panel"><div class="tbl-scroll"><table>
      <thead><tr>
        <th>Cliente</th><th>Parcela</th><th style="width:86px">Valor</th>
        <th style="width:96px">Liberada</th><th style="width:130px">Situação</th>
      </tr></thead>
      <tbody>${visiveis.map(c => `<tr>
        <td style="font-weight:600">${esc(c.casos?.cliente || "caso removido")}</td>
        <td>${NOME_ETAPA[c.etapa] || c.etapa}</td>
        <td class="mono" style="font-size:12.5px">${dinheiro(c.valor)}</td>
        <td class="mono" style="font-size:12px">${dataBR(c.liberado_em)}</td>
        <td><button class="acao" data-pg="${c.id}" data-estado="${c.pago ? 1 : 0}">${c.pago ? "Desfazer" : "Marcar paga"}</button></td>
      </tr>`).join("")}</tbody>
    </table></div></div>`
    : `<div class="panel"><div class="empty">
        <h3>${soPendentes ? "Nada pendente" : "Nenhuma comissão ainda"}</h3>
        <p>${soPendentes
          ? "Todas as comissões liberadas já foram pagas."
          : "As comissões são liberadas na ficha de cada caso, na seção Comissão."}</p></div></div>`}

    ${blocoRanking(ranking)}
    ${blocoConvites(convites)}`;

  $("#finPend").onclick = () => { soPendentes = !soPendentes; renderFinanceiro(); };

  $$("#vFinanceiro [data-pg]").forEach(b => b.onclick = async () => {
    b.disabled = true;
    try {
      await marcarPaga(b.dataset.pg, b.dataset.estado !== "1");
      await renderFinanceiro();
      toast("Pagamento atualizado");
    } catch (e){
      b.disabled = false;
      toast("Não deu para atualizar: " + (e.message || e));
    }
  });

  const bNovo = $("#cvNovo");
  if (bNovo) bNovo.onclick = async () => {
    bNovo.disabled = true; bNovo.textContent = "Gerando...";
    try {
      const codigo = await criarConvite();
      const copiou = await copiarTexto(codigo);
      await renderFinanceiro();
      toast(copiou ? `Código ${codigo} copiado, é só colar no WhatsApp` : `Código ${codigo} criado`);
    } catch (e){
      bNovo.disabled = false; bNovo.textContent = "Gerar convite";
      toast("Não deu para gerar: " + (e.message || e));
    }
  };

  $$("#vFinanceiro [data-cop]").forEach(b => b.onclick = async () => {
    const copiou = await copiarTexto(b.dataset.cop);
    toast(copiou ? `Código ${b.dataset.cop} copiado` : "Não deu para copiar");
  });
}

/* ------------------------------------------------------------- captador */

async function telaCaptador(alvo, pRanking){
  const [lista, ranking] = await Promise.all([listaComissoes(), pRanking]);

  const aReceber = lista.filter(c => !c.pago);
  const recebido = lista.filter(c => c.pago);
  const somar    = l => l.reduce((s, c) => s + Number(c.valor || 0), 0);

  /* Liberado no mês é o que ele produziu neste mês, tenha sido pago ou não.
     É de propósito que não seja o que caiu na conta: são coisas diferentes,
     e misturar as duas vira reclamação. */
  const agora = new Date();
  const noMes = lista.filter(c => {
    const d = new Date(c.liberado_em);
    return d.getFullYear() === agora.getFullYear() && d.getMonth() === agora.getMonth();
  });

  const semPix = !S.perfil?.pix;

  alvo.innerHTML = `
    ${semPix ? `<div class="fin-aviso">
      <div>
        <b>Falta cadastrar sua chave PIX</b>
        <p>É para onde a comissão é enviada. Sem a chave, o escritório não tem como pagar você.</p>
      </div>
      <button class="btn" id="finPix">Cadastrar chave</button>
    </div>` : ""}

    <div class="fin-topo">
      <div class="fin-caixa grande">
        <span>A receber</span>
        <b class="receber">${dinheiro(somar(aReceber))}</b>
        <i>${aReceber.length
          ? `${aReceber.length} parcela${aReceber.length === 1 ? "" : "s"} aguardando pagamento`
          : "nenhuma parcela em aberto"}</i>
      </div>
      <div class="fin-caixa">
        <span>Já recebido</span>
        <b class="neutro">${dinheiro(somar(recebido))}</b>
      </div>
      <div class="fin-caixa">
        <span>Liberado no mês</span>
        <b class="neutro">${dinheiro(somar(noMes))}</b>
      </div>
    </div>

    ${lista.length ? `<div class="panel" style="padding:13px 13px 6px;margin-bottom:14px">
      <p class="falta-tit" style="margin-bottom:9px">Suas parcelas</p>
      ${lista.map(c => `<div class="com-linha ${c.pago ? "paga" : "liberada"}">
        <div class="nm">
          <b>${esc(c.casos?.cliente || "caso removido")}</b>
          <span>${NOME_ETAPA[c.etapa] || esc(c.etapa)}, liberada em ${dataBR(c.liberado_em)}</span>
        </div>
        <span class="com-valor">${dinheiro(c.valor)}</span>
        <span class="com-tag ${c.pago ? "pg" : "ok"}">${c.pago
          ? `paga em ${dataBR(c.pago_em)}`
          : "a receber"}</span>
      </div>`).join("")}
      <p class="hint" style="padding:4px 2px 10px">Quem dá baixa no pagamento é o escritório.</p>
    </div>`
    : `<div class="panel" style="margin-bottom:14px"><div class="empty">
        <h3>Nada liberado por enquanto</h3>
        <p>Você ainda não tem comissão liberada. A primeira parcela é liberada
           quando a documentação do caso fica completa.</p></div></div>`}

    ${blocoRanking(ranking)}`;

  const bPix = $("#finPix");
  if (bPix) bPix.onclick = () => abrirPix();

  porSelo(somar(aReceber));
}

/* Resumo do que ele tem a receber, no alto da tela. É a informação que mais
   importa para o captador, e assim ela aparece sem precisar abrir o
   Financeiro. Fica escondida quando não há nada a receber. */
export async function atualizarSeloGanho(){
  if (S.souAdmin || !S.perfil) return;
  try {
    const [meu] = await resumoComissoes();
    porSelo(meu ? Number(meu.total_pendente) : 0);
  } catch (e){
    console.warn("selo do captador:", e);
  }
}

function porSelo(valor){
  const selo = $("#meuGanho");
  if (!selo || S.souAdmin) return;
  selo.textContent = `A receber ${dinheiro(valor)}`;
  selo.hidden = !(valor > 0);
}

/* -------------------------------------------------------------- ranking */

/* Posição e volume, nunca carteira: o que vem da função do banco já é só o
   agregado. Ranking de um não é ranking, então some com menos de dois. */
function blocoRanking(linhas){
  if (!linhas || linhas.length < 2) return "";

  const mes = new Date().toLocaleDateString("pt-BR", { month: "long" });

  return `<div class="panel rk">
    <div class="rk-topo">
      <h3>Ranking de ${mes}</h3>
      <span class="hint">casos cadastrados no mês</span>
    </div>
    ${linhas.map(l => `<div class="rk-linha${l.sou_eu ? " eu" : ""}">
      <span class="rk-pos p${l.posicao <= 3 ? l.posicao : "x"}">${l.posicao}</span>
      <span class="rk-nome">${esc(l.nome)}${l.sou_eu ? `<i>você</i>` : ""}</span>
      <span class="rk-casos">${l.casos}<small>caso${l.casos === 1 ? "" : "s"}</small></span>
    </div>`).join("")}
  </div>`;
}

/* ------------------------------------------------------------- convites */

/* Só o admin chega aqui, e a policy da tabela garante isso no banco.
   Devolve vazio quando a migração 005 ainda não rodou. */
function blocoConvites(convites){
  if (!convites) return "";

  const abertos = convites.filter(c => !c.usado_por);
  const usados  = convites.length - abertos.length;

  return `<div class="panel rk" style="margin-top:14px">
    <div class="rk-topo">
      <h3>Convites de captador</h3>
      <span class="hint">o código é o que libera o acesso de quem se cadastra</span>
    </div>
    ${abertos.length
      ? abertos.map(c => `<div class="cv-linha">
          <span class="cv-cod">${esc(c.codigo)}</span>
          <span class="hint">criado em ${dataBR(c.criado_em)}</span>
          <button class="acao" data-cop="${esc(c.codigo)}">Copiar</button>
        </div>`).join("")
      : `<p class="hint" style="margin-bottom:11px">Nenhum código em aberto. Gere um e mande para o captador novo.</p>`}
    <div class="cv-pe">
      <button class="btn" id="cvNovo">Gerar convite</button>
      <span class="hint">${usados} ${usados === 1 ? "código já usado" : "códigos já usados"}</span>
    </div>
  </div>`;
}
